import { render, staticRenderFns } from "./settings-presets-link.vue?vue&type=template&id=7a4bcc36&"
import script from "./settings-presets-link.vue?vue&type=script&lang=js&"
export * from "./settings-presets-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports